
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppContext from './context/AppContext';
import App from './App.jsx';
import './pages/index.scss';
import { HelmetProvider } from 'react-helmet-async';

// Suppress harmless ResizeObserver errors
const resizeObserverErrHandler = (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    return;
  }
};

window.addEventListener('error', resizeObserverErrHandler);

if (typeof window !== 'undefined') {
  require('bootstrap/dist/js/bootstrap');
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <AppContext>
          <App />
        </AppContext>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);